export default function (_this) {
  return {
    async create (data, cb) {
      const ganttOptions = {
        title: data.title,
        id: data.id,
        label: data.description,
        user: data.assignedTo,
        start: data.start,
        type: data.type,
        percent: data.percent,
        duration: data.duration,
        dataGrid: data.dataSource
      }
      const ganttId = await new Promise((resolve) => {
        const key = _this.getRef('widgetsData/ganttData').push(ganttOptions, () => {
          resolve(key)
        }).key
      })

      const widget = {
        template: `<GanttChart :chartId="'${ganttId}'" />`,
        gsOptions: data.gsOptions,
        tab: data.tab,
        subtab: data.subtab || null,
        layout: 'b-card'
      }

      const widgetKey = await new Promise((resolve) => {
        _this.widgets.create(widget, (key) => {
          resolve(key)
        })
      })

      _this.getRef(`widgets/${widgetKey}/dependency`)
      .set(`ganttData/${ganttId}`, () => (cb()))
    },
    readOptions (ganttId, cb) {
      _this.getRef('widgetsData/ganttData')
      .child(ganttId)
      .on('value', (snapshot) => {
        cb(snapshot.val())
      })
    },
    saveOptions (ganttId, options, cb) {
      _this.getRef('widgetsData/ganttData')
      .child(ganttId)
      .set(options, () => (cb()))
    }
  }
}
